import { combineReducers } from '@reduxjs/toolkit';

import auth from '../../features/auth/ducks';
import form from '../../features/form/ducks';
import home from '../../features/home/ducks';

export default combineReducers({
  auth,
  form,
  home,
});
